import { Formik, FormikConfig, FormikValues, useFormikContext } from "formik";
import { ReactNode } from "react";

type Props<Values> = FormikConfig<Values> & {
  children: ReactNode;
};
const Form = <T extends FormikValues>(props: Props<T>) => {
  return (
    <Formik {...props}>
      <Inner>{props.children}</Inner>
    </Formik>
  );
};

const Inner = (props: { children: ReactNode }) => {
  const { handleSubmit } = useFormikContext();
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault(); // prevent page refresh
        handleSubmit();
      }}
    >
      {props.children}
    </form>
  );
};

export { Form };
